import { SectionElementProps } from './components/SectionElement/SectionElement'

const lupus: SectionElementProps = {
    title: "Lupus Master",
    subtitle: "Available now",
    description: "Based on the famous social game \"Lupus in fabula\", Lupus Master brings players around a bonfire. Be a wolf, or a seer and much more and get your faction to victory!",
    mainImage: {
        alt: "lupus_icon",
        src: "./images/games/lupus_icon.png",
    },
    availabilityElements: [
        {
            href: "https://play.google.com/store/apps/details?id=com.matterflies.com.lupusmaster",
            src: "./images/google_play.png",
            alt: "Google Play",
        }
    ],
}
const ballInTheHole: SectionElementProps = {
    title: "Ball in the Hole",
    subtitle: "Available now",
    description: "Our first mobile game! Player has to tap on disks to let the balls fall into the color-matching hole. You can change balls and disks colors, for personalization and accessibility!",
    mainImage: {
        alt: "BIH",
        src: "./images/games/BIH_logo.jpg",
    },
    availabilityElements: [
        {
            href: "https://play.google.com/store/apps/details?id=com.station97.com.unity.ballinthehole&gl=US",
            src: "./images/google_play.png",
            alt: "google_play",
        }
    ],
}
const projectMaze: SectionElementProps = {
    title: "Project Maze",
    subtitle: "Coming Soon",
    description: "Our next Project! It will be aMAZEing",
    mainImage: {
        alt: "unknown",
        src: "./images/games/unknown.png",
    },
}
const samCamnasio: SectionElementProps = {
    title: "Samuele \"Sam\" Camnasio",
    description: "Developer",
    mainImage: {
        alt: "dev1",
        src: "./images/devs/sam.jpg",
    },
}
const ismaDjeba: SectionElementProps = {
    title: "Ismail \"Ismo\" Djebali",
    description: "Developer",
    mainImage: {
        alt: "dev2",
        src: "./images/devs/ismail.jpg",
    },
}
const vitLarovere: SectionElementProps = {
    title: "Vittorio \"Larry\" Larovere",
    description: "Developer",
    mainImage: {
        alt: "dev3",
        src: "./images/devs/vittorio.jpg",
    },
}
const matRedaelli: SectionElementProps = {
    title: "Matteo \"Reda\" Redaelli",
    description: "Developer",
    mainImage: {
        alt: "dev4",
        src: "./images/devs/matteo.jpg",
    },
}
const masZangirolami: SectionElementProps = {
    title: "Massimo \"Max\" Zangirolami",
    description: "Developer",
    mainImage: {
        alt: "dev4",
        src: "./images/devs/max.jpeg",
    },
}

const data = [
    [
        lupus,
        ballInTheHole,
        projectMaze,
    ],
    [
        samCamnasio,
        ismaDjeba,
        vitLarovere,
        matRedaelli,
        masZangirolami,
    ],
]

export { data }